import React from "react";
import { View, Text, StyleSheet, Platform } from "react-native";
import { STRINGS, COLORS } from "../../constants";

const ParkingDisclaimer = () => {
  return (
    <View style={styles.disclaimerContainer}>
      <Text style={styles.disclaimerText}>{STRINGS.parkingDisclaimer}</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  disclaimerContainer: {
    marginVertical: 8,
    paddingVertical: Platform.OS === "web" ? 12 : 8,
    paddingHorizontal: Platform.OS === "web" ? 8 : 4,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: COLORS.warning,
    backgroundColor: COLORS.warningLight,
  },
  disclaimerText: {
    color: COLORS.warningText,
    fontSize: Platform.OS === "web" ? 16 : 14,
  },
});

export default ParkingDisclaimer;
